import { render, staticRenderFns } from "./KeywordsTimelineDialog.vue?vue&type=template&id=3b06c59c&scoped=true"
import script from "./KeywordsTimelineDialog.vue?vue&type=script&lang=js"
export * from "./KeywordsTimelineDialog.vue?vue&type=script&lang=js"
import style0 from "./KeywordsTimelineDialog.vue?vue&type=style&index=0&id=3b06c59c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b06c59c",
  null
  
)

export default component.exports